<template>
  <div class="container">
    <div>技术支持：重庆市力合智控技术有限公司</div>
    <a href="https://beian.miit.gov.cn/" target="_blank">渝ICP备2022006452号-2</a>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'MyUiFooter',
  // 数据
  data() {
    return {}
  },
  // 生命周期函数
  created() {},
  // 计算属性
  computed: {},
  // 方法
  methods: {},
  // 组件
  components: {},
  // 自定义属性
  props: {}
}
</script>

<style scoped>
.container {
  display: flex;
  justify-content: center;
  padding-top: 30px;
}
.container div {
  cursor: default;
  font-size: 14px;
  line-height: 20px;
  color: deepskyblue;
  margin-right: 20px;
}
.container a {
  text-decoration: none;
  font-size: 14px;
  line-height: 20px;
  color: deepskyblue;
}
.container a:hover {
  font-size: 14px;
  line-height: 20px;
  color: deepskyblue;
}
</style>



// WEBPACK FOOTER //
// src/layout/UiFooter.vue